import React from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import { useGetTopSellingQuery } from '../apis/TopSelling';
import { CircularProgress } from '@mui/material';

const TopSellings = () => {
    const { 
        data: topSellings, 
        error, 
        isLoading 
    } = useGetTopSellingQuery();

    const SampleNextArrow = ({ onClick }) => (
        <button
            type="button" 
            onClick={onClick}
            className="slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1"
        >
            <i className="ph ph-caret-right" />
        </button>
    );

    const SamplePrevArrow = ({ onClick }) => (
        <button
            type="button"
            onClick={onClick}
            className="slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1"
        >
            <i className="ph ph-caret-left" />
        </button>
    );

    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 6,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1599,
                settings: { slidesToShow: 6 }
            },
            {
                breakpoint: 1399,
                settings: { slidesToShow: 4 }
            },
            {
                breakpoint: 992,
                settings: { slidesToShow: 3 }
            },
            {
                breakpoint: 575,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 424,
                settings: { slidesToShow: 1 }
            },
        ],
    };

     if (isLoading) return (
            <div className="flex-center py-20" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </div>
        ); 

    if (error) return <div>Error loading products: {error.message}</div>;

    return (
        <section className="organic-food py-30">
            <div className="container container-lg">
                <div className="section-heading">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0">Top sellings</h5>
                    </div>
                </div>
                <div className="organic-food__slider arrow-style-two">
                    <Slider {...settings}>
                        {topSellings?.map((product) => (
                            <div key={product.id}>
                                <div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                                    <Link
                                         to={`/displays-category/${product.subCategories.id}`}

                                        className="product-card__thumb flex-center"
                                    >
                                        <img 
                                            src={product.url} 
                                            alt={product.description} 
                                        />
                                    </Link>
                                    <div className="product-card__content mt-12">
                                       
                                        <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                            <Link 
                                                 to={`/displays-category/${product.subCategories.id}`}

                                                className="link text-line-2"
                                            >
                                                {product.description}
                                            </Link>
                                        </h6>
                                        <div className="flex items-center gap-4">
                            <span className="text-main-600 text-md flex">
                                <i className="ph-fill ph-storefront" />
                            </span>
                            <span className="text-gray-500 text-xs">
                                {product.categoryProduct?.name && product.subCategories?.name
                                ? `${product.categoryProduct.name} / ${product.subCategories.name}`
                                : 'Generic Store'}
                            </span>
                            </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    )
}

export default TopSellings;